module.exports = __webpack_public_path__ + "img/sound.b5e93734.jpg";